<template>
  <div class="invites-page brick">
    <invite-add-button
      class="add-button"
      @created="load"
    ></invite-add-button>

    <invites-list
      :invites="invites"
      @remove="showRemoveConfirmation"
    ></invites-list>

    <v-dialog v-model="removeDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Бажаєте видалити це запрошення?</v-card-title>
        <v-card-text>Видалене запрошення не може бути відновлено.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            @click.native="removeDialog = false; removeId = null;"
            :disabled="removing"
          >Відмінити</v-btn>
          <v-btn
            outline
            @click.native="remove(removeId)"
            :disabled="removing"
          >
            <v-progress-circular
              v-if="removing"
              :size="24"
              color="grey"
              indeterminate
            ></v-progress-circular>
            <span v-else>Видалити</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { getInvites, removeInvite } from '@/firebase/repositories/invites';

import InvitesList from '@/components/InvitesList';
import InviteAddButton from '@/containers/InviteAddButton';

export default {
  name: 'InvitesPage',
  components: {
    InvitesList,
    InviteAddButton,
  },
  data() {
    return {
      removeDialog: false,
      removeId: null,
      removing: false,
      invites: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      getInvites()
        .then((invites) => {
          this.invites = invites;
        });
    },
    showRemoveConfirmation(id) {
      this.removeId = id;
      this.removeDialog = true;
    },
    remove(id) {
      this.removing = true;
      removeInvite(id)
        .then(() => {
          this.removing = false;
          this.removeDialog = false;
          this.load();
        });
    },
  },
};

</script>

<style scoped>

.add-button {
  margin-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/containers/InvitesPage.vue